"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SilentAuthModel = exports.EAuthStatus = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var EAuthStatus;
exports.EAuthStatus = EAuthStatus;
(function (EAuthStatus) {
  EAuthStatus["Idle"] = "Idle";
  EAuthStatus["Fetching"] = "Fetching";
  EAuthStatus["SmsCodeSent"] = "SmsCodeSent";
  EAuthStatus["SmsCodeVerificationSuccess"] = "SmsCodeVerificationSuccess";
  EAuthStatus["InvalidSmsCode"] = "InvalidSmsCode";
  EAuthStatus["ServiceError"] = "ServiceError";
  EAuthStatus["AuthSuccess"] = "AuthSuccess";
})(EAuthStatus || (exports.EAuthStatus = EAuthStatus = {}));
var SilentAuthModel = /*#__PURE__*/function () {
  function SilentAuthModel(status, otac, username) {
    this.status = EAuthStatus.Idle;
    this.otac = void 0;
    this.username = void 0;
    this.status = status;
    if (!(0, _isNil.default)(otac)) this.otac = otac;
    if (!(0, _isNil.default)(username)) this.username = username;
  }
  SilentAuthModel.SmsCodeSent = function SmsCodeSent() {
    return new this(EAuthStatus.SmsCodeSent);
  };
  SilentAuthModel.SmsCodeVerificationSuccess = function SmsCodeVerificationSuccess(otac, username) {
    return new this(EAuthStatus.SmsCodeVerificationSuccess, otac, username);
  };
  SilentAuthModel.InvalidSmsCode = function InvalidSmsCode() {
    return new this(EAuthStatus.InvalidSmsCode);
  };
  SilentAuthModel.ServiceError = function ServiceError() {
    return new this(EAuthStatus.ServiceError);
  };
  return SilentAuthModel;
}();
exports.SilentAuthModel = SilentAuthModel;